import {FormInputElement} from "./formInputElement";
import {customElement} from "lit/decorators.js";
import type {Maybe} from "../../../bootstrap/common/types";

@customElement("eop-form-hidden-field")
export class EopFormHiddenField extends FormInputElement<string> {

    public constructor() {
        super("");
    }

    public setHiddenValue(hiddenValue: string): void {
        this.updateValue(hiddenValue);
    }

    protected preset(): Maybe<string> {
        return "";
    }

    public focusInput(): void {

    }
}